import { ExternalImageItem } from "../../domain/externalImage";

export interface IExternalImageStockable {
  getStockedExternalImage(patientId: string, imageId: string): ExternalImageItem;
}

export function instanceOfIExternalImageStockable(instance: any): instance is IExternalImageStockable {
  return instance
    && (instance.getStockedExternalImage !== undefined);
}
